import { Component } from '@angular/core';
import { MessageService, LazyLoadEvent } from 'primeng/api';
import { FoodService, ConfigService } from 'app/services';
import { Utils } from 'app/utils';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'food-restaurants',
    templateUrl: './food-restaurants.component.html',
    styleUrls: ['./food-restaurants.component.scss'],
    providers: [MessageService]
})
export class FoodRestaurantsComponent {
    public restaurants: Array<any> = [];

    public cols: any[] = [
        { field: 'Id', header: 'Id', width: '90px' },
        { field: 'CreatedAt', header: 'Created', width: '200px' },
        { field: 'Name', header: 'Name', width: '200px' },
        { field: 'ImageUrl', header: 'Image', width: '200px', disableSort: true }
    ];

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
    } = { searchName: '' };

    private searchTimer: number = 0;

    public editRestaurantId: number = 0;
    public showEditRestaurantPopup: boolean = false;

    constructor(
        private messageService: MessageService,
        private foodService: FoodService,
        public configService: ConfigService) {
        this.handleEditRestaurantPopupHide = this.handleEditRestaurantPopupHide.bind(this);
        this.handleEditRestaurantPopupSave = this.handleEditRestaurantPopupSave.bind(this);
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        //event.first = First row offset
        //event.rows = Number of rows per page
        //event.sortField = Field name to sort in single sort mode
        //event.sortOrder = Sort order as number, 1 for asc and -1 for dec in single sort mode
        //multiSortMeta: An array of SortMeta objects used in multiple columns sorting. Each SortMeta has field and order properties.
        //filters: Filters object having field as key and filter value, filter matchMode as value
        //globalFilter: Value of the global filter if available

        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getRestaurants(skip);
    }

    private getRestaurants(skip: number): void {
        const dto = {
            SearchName: this.filter.searchName,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };

        this.foodService.getRestaurants(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.restaurants = data.RestaurantList;

                this.restaurants.forEach(x => {
                    x.CreatedAt = Utils.utcToLocaleDateString(x.CreatedAt);
                });
            });
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRestaurants(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleCreateRestaurantClick(): void {
        this.editRestaurantId = 0;
        this.showEditRestaurantPopup = true;
    }

    public handleEditRestaurantClick(restaurant: any): void {
        this.editRestaurantId = restaurant.Id;
        this.showEditRestaurantPopup = true;
    }

    public handleEditRestaurantPopupHide(): void {
        this.showEditRestaurantPopup = false;
    }

    public handleEditRestaurantPopupSave(): void {
        this.handleFilterChange();
        this.showEditRestaurantPopup = false;

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully saved' });
    }
}
